<section class="flex justify-content-center wrapper mb-5 mt-4 pt-1">
    <div class="wrapper-content flex-column">
        <div class="border-round-3xl col-12 flex flex-column">
            <CustomTitle [title]="'Consulta SISBEN'"
                         styleClass="color-form-label font-normal font-roboto-condensed font-23 text-uppercase my-3 ml-6"/>
            <app-buscar-sisben [hiddenTitle]="true"
                    (sisben)="getSearchValues($event)"
                    (clearSearch)="clearSearch()"
                    [tiposIdentificaciones]="tiposIdentificaciones"/>
            <p-divider class="px-6 w-full h-3rem"/>
            <div class="col-12 flex flex-column px-6 pb-6">
                <div>
                    <CustomTitle title="Resultados de la búsqueda"
                                 styleClass="font-roboto-condensed color-form-label font-normal font-18 text-uppercase my-2"/>
                </div>
                <custom-table  [config]="configTable"/>
            </div>
        </div>
    </div>
</section>
